import request from '@/utils/request'

// 获取订单数据
export const getOrderListApi = (dataType, page) => {
  return request.get('/order/list', {
    params: {
      dataType, // 订单类型
      page // 获取几页
    }
  })
}

// 获取订单详情
export const getOrderDetailApi = (orderId) => {
  return request.get('/order/list', {
    params: {
      orderId
    }
  })
}

// 确认收货（买家本人）
export const confirmOrderApi = (orderId) => {
  return request.post('/order/confirm', {
    order_id: orderId
  })
}

// 申请退款（amount 可选，默认全额）
export const applyRefundApi = (orderId, reason, amount) => {
  return request.post('/order/applyRefund', {
    order_id: orderId,
    reason,
    amount
  })
}

// 我的退款记录
export const getMyRefundsApi = () => {
  return request.get('/order/myRefunds')
}

// 订单评价
export const commentOrderApi = (data) => {
  return request.post('/order/comment', data)
}
